<script setup>
import { useHead } from '#imports'
import { socialShareImage, usePageHead } from '@composables/use-page-head'
import { computed } from 'vue'
import { useAuthStore } from '@stores/auth'
import HomeUnAuth from '@router/views/homepage/homepage-unauth'
import HomeAuth from '@router/views/homepage/homepage-auth'

const authStore = useAuthStore()

const loggedIn = computed(() => authStore.loggedIn)

usePageHead({
    title: 'FRISKY — Underground Electronic Music Radio & DJ Mixes',
    description: 'Stream curated DJ mixes, live shows, and underground electronic music — house, techno, progressive, and more — on FRISKY since 2002.',
    image: socialShareImage(),
    canonical: 'https://frisky.fm/',
})

// The home title already carries the brand, so it opts out of app.vue's `| FRISKY` suffix.
useHead({ titleTemplate: '%s' })
</script>

<template>
    <BaseContent class="content">
        <HomeAuth v-if="loggedIn" />
        <HomeUnAuth v-else />
    </BaseContent>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
